import React from "react";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import DatePicker from "@mui/lab/DatePicker";
import { useIsMobile } from "../../Hooks";
import { TimeUtils } from "../../Utils";
import { FmTextField } from "../FmTextField";
import useStyles from "./FmDatePicker.style";

import TextField from "@mui/material/TextField";

import { useTheme } from "../../Hooks";

interface IFmDatePickerProps {
    label: string;
    helperText: string;
    onBlur: any;
    onChange: any;
    ref: any;
    error: any;
    inputProps: any;
    setValue: (value: any, params?: any) => void;
    value: string; // ASSUMES FORMAT OF TimeUtils.DEFAULT_DATE_FORMAT
    minDate?: string; // ASSUMES FORMAT OF TimeUtils.DEFAULT_DATE_FORMAT
    maxDate?: string; // ASSUMES FORMAT OF TimeUtils.DEFAULT_DATE_FORMAT
    defaultValue?: string; // ASSUMES FORMAT OF TimeUtils.DEFAULT_DATE_FORMAT
}

const FmDatePicker = React.forwardRef<any, any>((props: IFmDatePickerProps, ref) => {
    const { label, error, helperText, onBlur, onChange, value, setValue, minDate, maxDate, defaultValue } = props;
    const classes = useStyles();
    const theme = useTheme();

    const dateValue = value ? TimeUtils.createDate(value).toDate() : undefined;
    const minDateValue = minDate ? TimeUtils.createDate(minDate).toDate() : undefined;
    const maxDateValue = maxDate ? TimeUtils.createDate(maxDate).toDate() : undefined;
    const defaultDateValue = defaultValue ? TimeUtils.createDate(defaultValue).toDate() : undefined;

    const handleDateChange = (date: Date | null) => {
        const newDateFormatted = date ? TimeUtils.getDateFormatted(TimeUtils.convertToDayJs(date)) : undefined;
        setValue && setValue(newDateFormatted);
    };

    // const isRtl = theme.direction === 'rtl' ? true : false;

    return (
        <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
                views={["year", "month", "day"]}
                ref={ref}
                label={label}
                value={dateValue || defaultDateValue}
                minDate={minDateValue}
                maxDate={maxDateValue}
                onChange={handleDateChange}
                renderInput={(params) => (
                    <FmTextField
                        fullWidth={true}
                        spellCheck={false}
                        autoComplete='off'
                        inputRef={ref}
                        {...params}
                        label={label}
                        variant={"filled"}
                        error={error}
                        helperText={helperText}
                    />
                )}
            />
        </LocalizationProvider>
    );
});

export default FmDatePicker;
